export default __webpack_public_path__ + "static/media/virtual_services_price_fr.f5ab1eda.png";